// removed by extract-text-webpack-plugin
module.exports = {"productItem":"ProductListItem-module__productItem___3dl9c","linkProductItem":"ProductListItem-module__linkProductItem___3VTxJ"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ProductListItem/ProductListItem.module.css
// module id = 640
// module chunks = 0